/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { getUserGeo } from '@/utils/geo-info';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { autocomplete } from 'bootstrap-4-autocomplete';
import { tmpl } from '@/utils/util-extent';

const { $, google } = window;

let map = null;
let currentDatas = [];
let infoWindow = null;
const markers = [];
let markerCluster = null;
let geoLocation = null;
const pathOutput = '/bZ'; // /bZ
let highlightMarkerIndex = null;

function isMobile() {
  if ($(window).width() > 768) {
    return false;
  }
  return true;
}

// 顯示據點
function setMapOnAll(index) {
  markers[index].setVisible(true); // markers[index].setMap(map);
  // markerCluster.addMarker(markers[index]);
}

// 隱藏據點
function hideMarkers(index) {
  markers[index].setVisible(false); // markers[index].setMap(null);
  // markerCluster.removeMarker(markers[index]);
}

// 顯示 二位數邏輯、三位數邏輯
function ClusterLabel(count) {
  if (count < 10) {
    return String(count);
  }

  if (count < 100) {
    return `${String(count).substring(0, 1)}0+`;
  }
  if (count < 1000) {
    return `${String(count).substring(0, 1)}00+`;
  }
  return `${String(count).substring(0, 1)}000+`;
}

// 建置 群聚 MarkerCluster
function createMarkerCluster() {
  const defaultrenderer = {
    render: function renderer({ count, position }, stats) {
      const svg = window.btoa(`
        <svg width="42" height="47" viewBox="0 0 42 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1267_1597)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.8708 38.5672C24.0193 38.3099 24.2755 38.1335 24.5668 38.0754C32.6785 36.4567 38.7912 29.2967 38.7912 20.7091C38.7912 10.9286 30.8626 3 21.0821 3C11.3017 3 3.37305 10.9286 3.37305 20.7091C3.37305 28.9799 9.04299 35.9265 16.708 37.8738C16.9778 37.9424 17.212 38.1132 17.3512 38.3543L19.8064 42.6068C20.1913 43.2735 21.1536 43.2735 21.5385 42.6068L23.8708 38.5672Z" fill="#006D7A"/>
        </g>
        <defs>
        <filter id="filter0_d_1267_1597" x="0.373047" y="0" width="41.418" height="46.1064" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="1.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1267_1597"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1267_1597" result="shape"/>
        </filter>
        </defs>
        </svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(45, 47),
          anchor: new google.maps.Point(23, 47),
        },
        label: {
          text: ClusterLabel(count),
          color: 'rgba(255,255,255,0.9)',
          fontSize: '14px',
          className: 'marker-label',
        },
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  markerCluster = new MarkerClusterer({
    markers,
    map,
    onClusterClick: (_e, c, m) => {
      // c.bounds
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < c.markers.length; i += 1) {
        const position = new google.maps.LatLng(c.markers[i].position.lat(), c.markers[i].position.lng());
        bounds.extend(position);
      }
      // m.panTo(bounds.getCenter());
      m.fitBounds(bounds);
      m.panTo(bounds.getCenter());
    },
    algorithm: new SuperClusterAlgorithm({
      // radius: 40, 畫面半徑距離
      maxZoom: 14,
    }),
    renderer: defaultrenderer,
  });
}

// 資料處理-據點 Marker
function initMarkers(i) {
  const iconObj = {
    // size: new google.maps.Size(32, 36),
    scaledSize: new google.maps.Size(32, 36),
    anchor: new google.maps.Point(18, 34),
  };
  const iconObjActive = {
    anchor: new google.maps.Point(22, 48),
  };
  // 區分圖示 待確認-圖片顯示規則
  if (i.ViewInfo.toString().indexOf('AC') > -1) {
    iconObj.url = `${pathOutput}/public/images/icons/pin-AC.svg`;
    iconObjActive.url = `${pathOutput}/public/images/icons/pin-AC-active.svg`;
  }

  if (i.ViewInfo.toString().indexOf('DC') > -1) {
    iconObj.url = `${pathOutput}/public/images/icons/pin-DC.svg`;
    iconObjActive.url = `${pathOutput}/public/images/icons/pin-DC-active.svg`;
  }

  if (i.StationCategory === 'TOYOTA') {
    iconObj.url = `${pathOutput}/public/images/icons/pin-TOYOTA.svg`;
    iconObjActive.url = `${pathOutput}/public/images/icons/pin-TOYOTA-active.svg`;
  }

  const marker = new google.maps.Marker({
    position: new google.maps.LatLng(i.Latitude, i.Longitude),
    icon: iconObj,
    myDefaultIcon: iconObj,
    map,
  });
  markers.push(marker);
  // 取得路線
  let googleMapNav = '';
  if (geoLocation !== null) {
    googleMapNav = `https://www.google.com/maps/dir/${geoLocation.coords.latitude},${geoLocation.coords.longitude}/${i.Latitude},${i.Longitude}`;
  } else {
    googleMapNav = `https://www.google.com/maps/dir//${i.Latitude},${i.Longitude}`;
  }

  let viewinfohtml = '';
  i.ViewInfo.forEach((e) => {
    viewinfohtml += `<div class="font-s-2">${e}</div>`;
  });

  const markerInfo = `
      <article class="map-info-window">
        <div class="font-light mb-1">
        ${i.StationCategory}
        </div>
        <h5 class="font-bold font-s-1">
        ${i.StationName}
        </h5>
        <div class="font-s-2 mb-2">
        ${i.City}${i.Area}${i.Address}
        </div>
        <div class="border-bottom mb-4 pb-4 font-s-3">
          <i class="icon-bz icon-clock"></i> ${i.BusinessHours}
        </div>
        <div class="font-bold font-s-2">
          <i class="icon-bz icon-chargeformat"></i> 充電資訊
        </div>
        <div class="font-light mb-4">
          ${viewinfohtml}
        </div>
        <div class="mb-4 font-s-3"> 
          *bZ4X支援DC快充及AC慢充，PRIUS PHEV支援AC慢充
        </div>
        <div class="d-flex justify-content-end text-bluegreen-1">
          <a href="${googleMapNav}" target="_blank" class="font-s-2">
            <i class="icon-bz icon-GPS"></i> 路徑規劃
          </a>
        </div>
      </article>`;

  // eslint-disable-next-line no-shadow
  google.maps.event.addListener(marker, 'click', (function mark(marker, i) {
    return function window() {
      // marker 回歸預設狀態
      if (highlightMarkerIndex !== null) {
        markers[highlightMarkerIndex].setIcon(markers[highlightMarkerIndex].myDefaultIcon);
      }
      highlightMarkerIndex = i.ID;
      marker.setIcon(iconObjActive);
      infoWindow.setContent(markerInfo);
      infoWindow.close();
      if (map.zoom < 15) {
        map.setZoom(15);
      }
      map.panTo(marker.getPosition(0, 110));
      infoWindow.open(map, marker);
    };
  }(marker, i)));
}

// 資料處理-縣市
function initCity(i, $obj) {
  const select = $obj;
  const cityValue = encodeURIComponent(i.City);
  if (select.find(`option[value="${cityValue}"]`).length > 0) {
    return;
  }
  const option = document.createElement('option');
  option.value = cityValue;
  option.textContent = cityValue;
  select.append(option);
}

function onAutoSelectItem(item) {
  console.log(item);

  for (let i = 0; i < currentDatas.length; i += 1) {
    const data = currentDatas[i];
    if (item.label === `${data.Address} ${data.StationName}`) {
      if (highlightMarkerIndex !== null) {
        markers[highlightMarkerIndex].setIcon(markers[highlightMarkerIndex].myDefaultIcon);
      }
      infoWindow.close();
      // eslint-disable-next-line new-cap
      const _ = new google.maps.event.trigger(markers[i], 'click');
      return;
    }
  }
}
// 資料處理
function initData(datas) {
  const select = $('#city_pc, #city_mobile');
  select.html('<option selected disabled>縣市</option><option selected value="">全部</option>');
  datas.forEach((i, index) => {
    initMarkers(i);
    initCity(i, $('#city_pc'));
    initCity(i, $('#city_mobile'));
    // 動態lable enable
    i.lable = `${i.Address} ${i.StationName}`;
    i.enable = true;
    i.ID = index;
  });
  createMarkerCluster();
  const autocompleteConfig = {
    source: datas,
    label: 'lable',
    highlightClass: 'text-danger',
    treshold: 2,
    maximumItems: 5,
    onSelectItem: onAutoSelectItem,
  };
  $('#keywords-input-pc').autocomplete(autocompleteConfig);
  $('#keywords-input-mobile').autocomplete(autocompleteConfig);
  infoWindow.addListener('closeclick', () => {
    markers[highlightMarkerIndex].setIcon(markers[highlightMarkerIndex].myDefaultIcon);
  });
}

// 縣市cityChange
function cityChange() {
  console.log('change');
  const val = $(this).val();
  const select = $(this).attr('id') === 'city_pc' ? $('#area_pc') : $('#area_mobile');
  select.html('<option selected disabled>區域</option><option selected value="">全部</option>');
  const option = '<option value="{{ Area }}">{{ Area }}</option>';
  currentDatas.forEach((i) => {
    if (i.City === val && select.find(`option[value=${i.Area}]`).length === 0) {
      const tmp = tmpl(option, i);
      select.append(tmp);
    }
  });
}
//
// 模糊查詢判斷
// 搜尋click
function searchClick() {
  let val = $('#keywords-input-pc').val();
  let cityVal = $('#city_pc').val();
  let areaVal = $('#area_pc').val();
  if (isMobile()) {
    val = $('#keywords-input-mobile').val();
    cityVal = $('#city_mobile').val();
    areaVal = $('#area_mobile').val();
  }
  if (val === '' && (cityVal === '' || cityVal === null) && (areaVal === '' || areaVal === null)) {
    // eslint-disable-next-line no-alert
    alert('請選擇縣市區域或輸入地址或名稱!');
    return;
  }
  const filters = [];
  currentDatas.forEach((i, index) => {
    if ((i.City === cityVal || cityVal === '' || cityVal === null) && (i.Area === areaVal || areaVal === '' || areaVal === null)) {
      if (val === '') {
        filters.push(index); // 顯示縣市 區域
      } else {
        // 模糊找到相關位置
        const valarray = val.split(' ');
        for (let j = 0; j < valarray.length; j += 1) {
          const v = valarray[j];
          const checkAddr = `${i.City}${i.Area}${i.Address}`;
          if (v.trim() !== '' && (i.StationName.indexOf(v) > -1 || checkAddr.indexOf(v) > -1)) {
            filters.push(index);
            break;
          }
        }
      }
    }
  });

  if (highlightMarkerIndex !== null) {
    markers[highlightMarkerIndex].setIcon(markers[highlightMarkerIndex].myDefaultIcon);
  }
  infoWindow.close();

  if (filters.length === 0) {
    // 第二次查詢直接查詢輸入欄位
    if (val.trim() === '') {
      // eslint-disable-next-line no-alert
      alert('查無相關充電站!');
      return;
    }
    currentDatas.forEach((i, index) => {
      // 模糊找到相關位置
      const valarray = val.split(' ');
      for (let j = 0; j < valarray.length; j += 1) {
        const v = valarray[j];
        const checkAddr = `${i.City}${i.Area}${i.Address}`;
        if (v.trim() !== '' && (i.StationName.indexOf(v) > -1 || checkAddr.indexOf(v) > -1)) {
          filters.push(index);
          break;
        }
      }
    });
    if (filters.length === 0) {
      // eslint-disable-next-line no-alert
      alert('查無相關充電站!');
      return;
    }
  }
  if (filters.length === 1) {
    const index = filters[0];
    // eslint-disable-next-line new-cap
    const _ = new google.maps.event.trigger(markers[index], 'click');
    return;
  }

  const bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < filters.length; i += 1) {
    const index = filters[i];
    const position = new google.maps.LatLng(markers[index].position.lat(), markers[index].position.lng());
    bounds.extend(position);
  }
  // m.panTo(bounds.getCenter());
  map.fitBounds(bounds);
  map.panTo(bounds.getCenter());
}
// 篩選
function filter() {
  const valtypes = [];
  const valstations = [];
  $('input[name=chargingType]:checked').each(function get() {
    valtypes.push($(this).val());
  });
  $('input[name=charging]:checked').each(function get() {
    valstations.push($(this).val());
  });
  let showCount = 0;
  const removeMarkers = [];
  const addMarkers = [];
  currentDatas.forEach((i, index) => {
    // 充電類型
    let hasType = false;
    for (let j = 0; j < valtypes.length; j += 1) {
      const type = valtypes[j];
      if (i.ViewInfo.toString().indexOf(type) > -1) {
        hasType = true;
        break;
      }
    }
    // 充電站
    const hasStation = valstations.includes(i.StationCategory);
    if (hasType && hasStation) {
      if (i.enable === false) {
        setMapOnAll(index);
        addMarkers.push(markers[index]);
        i.enable = true;
      }
      showCount += 1;
    } else if ((hasType === false || hasStation === false) && i.enable === true) {
      hideMarkers(index);
      removeMarkers.push(markers[index]);
      i.enable = false;
    }
  });
  if (addMarkers.length > 0) {
    markerCluster.addMarkers(addMarkers);
  }
  if (removeMarkers.length > 0) {
    markerCluster.removeMarkers(removeMarkers);
  }
  // $('#filterCount').text(`符合條件筆數：${showCount}`);
}
// 取得APi資料
function getData() {
  $.ajax({
    url: 'api/charging.ashx',
    type: 'POST',
    dataType: 'json',
    data: { },
    success: (result) => {
      if (result.returnCode === '0000') {
        currentDatas = result.datas;
        initData(currentDatas);
      }
    },
  }).fail((e) => {
    console.log('error', e);
  });
}

function getCurrentPosition() {
  return new Promise((resolve) => {
    if ('geolocation' in navigator) {
      setTimeout(() => {
        resolve(null);
      }, 1000); // 1秒後取不到定位，回傳null
      navigator.geolocation.getCurrentPosition((position) => {
        geoLocation = position; // 取得定位
        console.log(geoLocation);
        resolve(position);
      });
    } else {
      resolve(null);
    }
  });
}

export function init(mapObject) {
  map = mapObject;

  // infoWindow
  infoWindow = new google.maps.InfoWindow({
    minWidth: 320,
    pixelOffset: new google.maps.Size(0, -5),
  });
  // 點選我的位置
  $('#getmygeo, #getmygeo-mobile').on('click', () => {
    if (geoLocation === null) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            geoLocation = position;
            if (map.zoom < 13) {
              map.setZoom(13);
            }
            map.panTo(new google.maps.LatLng(geoLocation.coords.latitude, geoLocation.coords.longitude));
          },
          () => {
            // eslint-disable-next-line no-alert
            alert('Google定位服務異常!');
          },
        );
      } else {
        // eslint-disable-next-line no-alert
        alert('瀏覽器無法定位!');
      }
    } else {
      if (map.zoom < 13) {
        map.setZoom(13);
      }
      map.panTo(new google.maps.LatLng(geoLocation.coords.latitude, geoLocation.coords.longitude));
    }
  });

  getCurrentPosition();

  getData();

  // select change事件觸發失效原因不明
  $('#city_pc').on('change', cityChange);
  $('#city_mobile').on('change', cityChange);

  $('#btnSearch-pc, #btnSearch-mobile').on('click', searchClick);
  $('#popup-filter input[type=checkbox]').on('click', filter);
}

export default {
  init,
};
